import {useAtomValue} from 'jotai';
import {useEffect, useMemo} from 'react';
import {getCategoryIcon} from '@/components/CategoryIcon';
import {KodataStoreData, KodataStoreDetailData} from '@/map/@types';
import {mapInstanceAtom} from '@/map/atom';
import {convertToCoordFromPointCoords, convertToMyfcCategoryFromKodata} from '@/map/utils';
import {getCategoryId} from '@/utils';
import {LocationMarker} from './LocationMarker';
import {RoundColorContent} from './RoundColorMarker/RoundColorContent';

interface IProps {
  preventPanToAction?: boolean;
  item: KodataStoreData | KodataStoreDetailData;
  onClose?(): void;
}

export const StoreSpotMarker = ({
  item,
  preventPanToAction,
  onClose,
}: IProps) => {
  const map = useAtomValue(mapInstanceAtom);
  const latlng = useMemo(
    () =>
      map &&
      item?.location?.coordinates &&
      convertToCoordFromPointCoords(item.location.coordinates),
    [item?.location?.coordinates, map]
  );

  const category = useMemo(
    () => convertToMyfcCategoryFromKodata(item.businessItemName),
    [item?.businessItemName]
  );
  const categoryId = useMemo(() => getCategoryId(category), [category]);
  const icon = useMemo(() => getCategoryIcon(categoryId, 16), [categoryId]);
  const Content = useMemo(
    () => (
      <RoundColorContent
        size="small"
        icon={icon}
        style={{
          flexShrink: 0,
          marginRight: 4,
          marginTop: 2,
        }}
      />
    ),
    [icon]
  );

  useEffect(() => {
    if (!preventPanToAction && latlng && map) {
      map.panTo(latlng);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [item, map]);

  if (!map || !latlng) {
    return null;
  }

  return (
    <LocationMarker
      map={map}
      position={latlng}
      address={item.brandName}
      iconComponent={Content}
      onClose={onClose}
    />
  );
};
